import React from 'react';
import PropTypes from 'prop-types';

/**
 * A component for displaying individual results
 */
function MetaBodyList({ label, value, colon = true }) {
  return (
    <span className="body__meta meta--list">
      <strong>
        {label}
        {colon ? ': ' : ' '}
      </strong>
      <span>{value}</span>
    </span>
  );
}

MetaBodyList.propTypes = {
  /**
   * The label
   */
  label: PropTypes.string.isRequired,
  /**
   * The value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]).isRequired,
  /**
   * The colon flag
   */
  colon: PropTypes.bool
};

export default MetaBodyList;
